<template>
  <div class="vwrap">
    <template v-if="data.videoUrl">
      <div class="title">
        I 店主视频介绍
      </div>
      <div class="video">
        <video
          v-if="playVideo"
          class="video-content"
          :src="data.videoUrl"
          :poster="data.videoUrl + '?vframe/jpg/offset/1'"
          autoplay
          controls
        ></video>
        <div v-else @click="playVideoAction()" class="videoimg">
          <img
            class="playicon"
            src="https://img.zai-art.com/zaiart/saas/image/md/92f3f7550d47247c24819039319e6251.png"
            alt=""
          />
          <img class="imgbg" :src="data.videoUrl + '?vframe/jpg/offset/1'" alt="" />
        </div>
      </div>
    </template>

    <div v-if="data.videoUrl" class="vline"></div>
    <div class="title">
      I 简介
    </div>
    <div class="subject">{{ data.subject }}</div>
    <div v-if="data.situation || data.videoUrl" class="vline"></div>
    <div v-if="data.situation" class="situation">{{ data.situation }}</div>
    <div v-if="false" class="buy"><a :href="'tel:' + data.phone">购买咨询</a></div>
  </div>
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
      playVideo: false,
    };
  },
  created() {},
  methods: {
    playVideoAction() {
      this.playVideo = true;
    },
  },
};
</script>
<style lang="less" scoped>
.vwrap {
  background: #fff;
  padding: 16px;
  // position: sticky;
  // top: 199px;
  .title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
    line-height: 18px;
    margin-bottom: 16px;
  }
  .video {
    position: relative;
    width: 208px;
    height: 117px;
    margin-bottom: 12px;
    video {
      width: 208px;
      height: 117px;
    }
    .videoimg,
    .imgbg {
      display: block;
      width: 208px;
      height: 117px;
      position: relative;
      .playicon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 26px;
        height: 26px;
        z-index: 99;
      }
    }
  }
  .situation {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    margin-bottom: 16px;
    word-wrap: break-word;
    white-space: pre-line;
  }
  .vline {
    width: 100%;
    height: 1px;
    border: 1px solid #e5e5e5;
    margin-bottom: 15px;
  }
  .subject {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    overflow-y: auto;
    height: 220px;
    // text-overflow: -o-ellipsis-lastline;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-line-clamp: 11;
    // -webkit-box-orient: vertical;
    margin-bottom: 20px;
    word-wrap: break-word;
    white-space: pre-line;
  }
  .buy {
    width: 208px;
    height: 40px;
    line-height: 40px;
    background: #222222;
    border-radius: 4px;
    margin: 0 auto;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
